/** True when the user is on the free tier or subscription access is unknown. */
export function isFreeUser(): boolean {
  const access = localStorage.getItem('access');
  return !access || access === 'null' || access === 'free';
}

/** True when the user has a paid (non-free) subscription. */
export function hasPremiumAccess(): boolean {
  return !isFreeUser();
}
